module.exports = __webpack_public_path__ + "static/media/app_icon.d9749044.svg";